import { render, staticRenderFns } from "./AddResellerInvoiceComponent.vue?vue&type=template&id=72e9d111&"
import script from "./AddResellerInvoiceComponent.vue?vue&type=script&lang=js&"
export * from "./AddResellerInvoiceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports